import { render, staticRenderFns } from "./InStoreAppointmentServiceDetails.vue?vue&type=template&id=370f74da&scoped=true"
import script from "./InStoreAppointmentServiceDetails.vue?vue&type=script&lang=js"
export * from "./InStoreAppointmentServiceDetails.vue?vue&type=script&lang=js"
import style0 from "./InStoreAppointmentServiceDetails.vue?vue&type=style&index=0&id=370f74da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f74da",
  null
  
)

export default component.exports